module.exports = __webpack_public_path__ + "img/emoji-mistake-emoji-240x240.77938816.png";